document.addEventListener("DOMContentLoaded", () => {
  const brandSelect = document.querySelector("[data-brand]");
  const modelSelect = document.querySelector("[data-model]");
  const resultBtn = document.querySelector("[data-compatibility]");
  const errorMessage = document.querySelector("[data-error-meesage]");
  const jsonEl = document.querySelector("[data-vehicle-json]");
  const resultBtnSpan = resultBtn.querySelector("[data-compatibility-text]");
  const defaultButtonText = resultBtn.dataset.buttonText || "Search";
  const selectedButtonText = resultBtn.dataset.label || "Join the team";
  let vehicles = [];
  try {
    const data = JSON.parse(jsonEl.textContent);
    vehicles = data.names_models.vehicles || [];
  } catch (err) {
    console.error('JSON parse error:', err);
    return;
  }
  const modelOptionsMap = {};
  vehicles.forEach((vehicle) => {
    const brandSlug = vehicle.make.toLowerCase().replace(/\s+/g, "-");
    modelOptionsMap[brandSlug] = vehicle.models || [];
  });
  brandSelect.innerHTML = '<option value="">Select Brand</option>';
  vehicles.forEach((vehicle) => {
    const opt = document.createElement("option");
    opt.value = vehicle.make.toLowerCase().replace(/\s+/g, "-");
    opt.textContent = vehicle.make;
    brandSelect.appendChild(opt);
  });
  brandSelect.addEventListener("change", () => {
    const selectedBrand = brandSelect.value;
    const models = modelOptionsMap[selectedBrand] || [];
    modelSelect.innerHTML = '<option value="">Select Model</option>';
    models.forEach((m) => {
      const opt = document.createElement("option");
      opt.value = m.name;
      opt.textContent = m.name;
      modelSelect.appendChild(opt);
    });
    if (resultBtnSpan) resultBtnSpan.textContent = defaultButtonText;
    resultBtn.classList.remove("compatibility__button-active");
  });
  modelSelect.addEventListener("change", () => {
    if (brandSelect.value && modelSelect.value) {
      resultBtn.classList.add("compatibility__button-active");
      if (resultBtnSpan) resultBtnSpan.textContent = selectedButtonText;
    } else {
      resultBtn.classList.remove("compatibility__button-active");
      if (resultBtnSpan) resultBtnSpan.textContent = defaultButtonText;
    }
  });
  resultBtn.addEventListener("click", (event) => {
    if (!brandSelect.value || !modelSelect.value) {
      event.preventDefault();
      if (errorMessage) {
        errorMessage.textContent = !brandSelect.value
          ? "Please select brand & model"
          : "Please select model";
        setTimeout(() => (errorMessage.textContent = ""), 4000);
      }
    }
  });
  window.addEventListener("pageshow", () => {
    brandSelect.selectedIndex = 0;
    modelSelect.innerHTML = '<option value="">Select Model</option>';
    if (resultBtnSpan) resultBtnSpan.textContent = defaultButtonText;
    resultBtn.classList.remove("compatibility__button-active");
  });
});
window.addEventListener("load", () => {
  const header = document.querySelector("[data-sticky-type]");
  const hash = location.hash.slice(1);
  const target = document.querySelector(`[data-scroll-target="${hash}"]`);
  if (header) header.classList.add("header--no-transition");
  if (target) {
    setTimeout(() => {
      const rect = target.getBoundingClientRect();
      const offset = rect.top + window.scrollY - window.innerHeight / 2 + rect.height / 2;
      window.scrollTo({ top: offset, behavior: "smooth" });
    }, 100);
  }
  setTimeout(() => {
    if (header) header.classList.remove("header--no-transition");
  }, 1000);
});
